'use strict';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { UserStorage } from './user-storage';
import { User } from './user';
import { routeData } from '../shared/route-helpers';

@Component({
    selector: 'user-settings',
    template: require('./user-settings.component.html'),
    styles: [require('./user-settings.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSettingsComponent {
    public readonly userFullName$: Observable<string>;

    constructor(
        private readonly route: ActivatedRoute,
        userStorage: UserStorage
    ) {
        const editedUser$ = this.route.data.pipe(
            filter(x => !!x),
            map(data => (data[routeData.user] as User))
        );

        this.userFullName$ = combineLatest([editedUser$, userStorage.currentUser])
            .pipe(map(([editedUser, currentUser]: [User, User]) => {
                return editedUser.metadata.userId === currentUser.metadata.userId
                    ? ''
                    : editedUser.metadata.fullName;
            }));
    }
}
